import Field from './field';

const TEXT_SELECT_PLACEHOLDER = 'Sélectionner une option…';

export default class FieldState extends Field {
	constructor(el) {
		super(el);

		this.refs.svg = this.el.querySelector('svg');

		this.state = {
			type: this.el.dataset.inputField,
		};
	}

	updateOptions(states) {
		if (typeof states === 'undefined') {
			if (this.state.type !== 'text') this.changeToInputText();
		}
		else {
			if (this.state.type !== 'select') this.changeToInputSelect();
			else this.removeOptions();

			if (states.length === 0) {
				this.hide();
				return;
			}

			this.addOptions(states);
		}
		this.show();
	}

	changeToInputText() {
		// Update label
		this.refs.label.classList.remove('input-select__label');
		this.refs.label.classList.add('input-text__label');

		// Create input text
		const inputText = document.createElement('input');
		inputText.type = 'text';
		inputText.className = 'input-text__field';
		inputText.name = this.refs.input.name;
		inputText.id = this.refs.input.id;
		inputText.autocomplete = this.refs.input.autocomplete;

		// Swap select to text
		this.el.removeChild(this.refs.input);
		this.el.insertAdjacentElement('beforeend', inputText);
		this.refs.input = inputText;

		// Remove SVG
		this.el.removeChild(this.refs.svg);

		// Update the element & trigger event
		this.el.classList.remove('input-select');
		this.el.classList.add('input-text');
		this.el.dataset.inputField = 'text';
		this.state.type = 'text';
		this.triggerEvent();
	}

	changeToInputSelect() {
		// Update label
		this.refs.label.classList.remove('input-text__label');
		this.refs.label.classList.add('input-select__label');

		// Create select input
		const selectInput = document.createElement('select');
		selectInput.className = 'input-select__field';
		selectInput.name = this.refs.input.name;
		selectInput.id = this.refs.input.id;
		selectInput.autocomplete = this.refs.input.autocomplete;

		// Swap select to text
		this.el.removeChild(this.refs.input);
		this.el.insertAdjacentElement('beforeend', selectInput);
		this.refs.input = selectInput;

		// Update the element & trigger event
		this.el.classList.remove('input-text');
		this.el.classList.add('input-select');
		this.el.dataset.inputField = 'select';
		this.state.type = 'select';
		this.triggerEvent();

		if (!this.refs.svg) {
			this.el.insertAdjacentHTML('beforeend', '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="10"><path fill="#000" fill-rule="nonzero" d="M9.25 8.1746212L1.11827202.04289322.41116524.75 9.25 9.58883476 18.08883476.75l-.70710678-.70710678z"></path></svg>')
			this.refs.svg = this.el.querySelector('svg');
		}
		else {
			this.el.insertAdjacentElement('beforeend', this.refs.svg);
		}
	}

	triggerEvent() {
		this.el.dispatchEvent(new CustomEvent('input:swap'));
	}

	removeOptions() {
		while (this.refs.input.firstElementChild) {
			this.refs.input.removeChild(this.refs.input.firstElementChild);
		}
	}

	addOptions(options) {
		// Add placeholder option
		const placeholder = document.createElement('option');
		placeholder.setAttribute('value', '');
		placeholder.setAttribute('disabled', true);
		placeholder.setAttribute('selected', true)
		placeholder.innerText = TEXT_SELECT_PLACEHOLDER;
		this.refs.input.insertAdjacentElement('beforeend', placeholder);

		// Add options
		for (const [value, label] of Object.entries(options)) {
			const opt = document.createElement('option');
			opt.setAttribute('value', value);
			opt.innerText = label;
			this.refs.input.insertAdjacentElement('beforeend', opt);
		}
	}
}
